import { Utils } from './utils';
const formSelector = ".contact-form";
const validationRules = {
    firstName: {
        required: true,
    },
    lastName: {
        required: true,
    },
    email: {
        required: true,
        email: true,
    },
    phone: {
        required: true,
    },
    message: {
        required: true,
    },
    privacyPolicyAccepted: {
        required: true,
    }
};
const validationMessages = {
    firstName: {
        required: "Please provide your first name",
    },
    lastName: {
        required: "Please provide your last name",
    },
    email: {
        required: "Please enter your email",
        email: "Please enter a valid email address"
    },
    phone: {
        required: "Please provide a phone number for contact purposes",
    },
    message: {
        required: "Please provide a message to send",
    },
    privacyPolicyAccepted: {
        required: "Please accept our privacy policy"
    }
};
window.addEventListener("load", () => {
    // Initializes form validation and submission for the Enquire Now form, if
    // one is present on the form. Successful submission results in a redirect to a thank you
    // page, since we validate server side the only failure mode is recapture failure.
    Utils.InitializeFormValidation(formSelector, validationRules, validationMessages);
});
